@if (checkoutProgress$ | async; as checkoutProgress) {
  <div class="checkout-steps">
    <div class="list-wrapper">
      <ul class="step-list">
        @for (
          checkoutStep of checkoutProgress.checkoutSteps;
          track checkoutStep;
          let i = $index
        ) {
          <li
            class="active-link"
            [ngClass]="{
              'active-link': checkoutStep.step <= checkoutProgress.index,
            }"
          >
            @if (checkoutStep.step < checkoutProgress.index) {
              <boels-generic-link [url]="checkoutStep.url">
                @if (i !== 0) {
                  <fa-icon size="xs" [icon]="faChevronRight"></fa-icon>
                }
                <span class="step-number">{{ checkoutStep.step }}</span>
                {{ checkoutStep.localizedTitle | transloco }}
              </boels-generic-link>
            } @else {
              <div class="step">
                @if (i !== 0) {
                  <fa-icon size="xs" [icon]="faChevronRight"></fa-icon>
                }
                <span class="step-number">{{ checkoutStep.step }}</span>
                {{ checkoutStep.localizedTitle | transloco }}
              </div>
            }
          </li>
        }
      </ul>
    </div>
  </div>
}
